import React from 'react';
import Message from './Message';
import TypingIndicator from './TypingIndicator';
import './MessageList.css';

const MessageList = ({ messages, isLoading, onFavoriteCompound, endRef, emptyLabel }) => {
  return (
    <div className="message-list">
      {messages.length === 0 && !isLoading && emptyLabel && (
        <div className="message-list-empty">
          <p>Ask me anything about <strong>{emptyLabel}</strong>.</p>
          <p className="message-list-empty-hint">Payment terms, delivery, unit sizes — or how it compares with what you have saved.</p>
        </div>
      )}
      {messages.map(message => (
        <Message
          key={message.id}
          message={{ ...message, onFavoriteCompound }}
        />
      ))}
      {isLoading && <TypingIndicator />}
      <div ref={endRef} />
    </div>
  );
};

export default MessageList;
